import {
    createRouter,
    createWebHistory
} from 'vue-router'


const routes = [{
    path: '/',
    redirect: '/index'
},
{
    path: '/index',
    meta: {
        title: '首页'
    },
    component: () => import('@/views/MyHome.vue')
},
{
    path: '/platformAnnouncements',
    meta: {
        title: '招标信息'
    },
    component: () => import('@/views/PlatformAnnouncements.vue')
},
{
    path: '/platformAnnouncementsDetail',
    meta: {
        title: '招标信息详情'
    },
    component: () => import('@/views/PlatformAnnouncementsDetail.vue')
},
{
    path: '/aboutventureCapital',
    meta: {
        title: '关于创投'
    },
    component: () => import('@/views/AboutVentureCapital.vue')
},
{
    path: '/platformDynamics',
    meta: {
        title: '平台动态'
    },
    component: () => import('@/views/PlatformDynamics.vue')
},
{
    path: '/platformDynamicsDetail',
    meta: {
        title: '平台动态详情'
    },
    component: () => import('@/views/PlatformDynamicsDetail.vue')
},
{
    path: '/bulletinII',
    meta: {
        title: '公告二级'
    },
    component: () => import('@/views/BulletinII.vue')
},
{
    path: '/helpCenter',
    meta: {
        title: '帮助中心'
    },
    component: () => import('@/views/HelpCenter.vue')
},
{
    path: '/proceDure',
    meta: {
        title: '操作流程'
    },
    component: () => import('@/views/ProceDure.vue')
},
{
    path: '/aboutUs',
    meta: {
        title: '关于我们'
    },
    component: () => import('@/views/AboutUs.vue')
},
{
    path: '/recruitmentAnnouncement',
    meta: {
        title: '招募公告'
    },
    component: () => import('@/views/RecruitmentAnnouncement.vue')
},
{
    path: '/recruitmentAnnouncementDetail',
    meta: {
        title: '招募公告详情'
    },
    component: () => import('@/views/RecruitmentAnnouncementDetail.vue')
}
]


const router = createRouter({
    routes,
    history: createWebHistory()
})


router.beforeEach((to, from, next) => {
    document.title = "鹏飞集团电子招投标交易平台系统"
    document.documentElement.scrollTop = 0
    next()
})

export default router